import * as React from 'react';

import { getIconStyle, Icon, type IconProps, IconStyle, useIcons } from '@gitbook/icons';
import { getInlineIconSourceKey } from '@gitbook/icons/IconSources';

import { useLoadIconSources } from './IconSources';

/**
 * Renders a GitBook content icon only when inline SVG source markup is available.
 */
export function ContentIcon({ ref, ...props }: IconProps & { ref?: React.Ref<SVGSVGElement> }) {
    const context = useIcons();
    const loadIconSources = useLoadIconSources();
    const { icon: propIcon, iconStyle: propIconStyle } = props;
    const requestedIconStyle = propIconStyle ?? context.iconStyle ?? IconStyle.Regular;
    const [iconStyle, icon] = getIconStyle(requestedIconStyle, propIcon);
    const source = context.iconSources?.[getInlineIconSourceKey(iconStyle, icon)];

    React.useEffect(() => {
        if (!source) {
            loadIconSources({ icon: propIcon, iconStyle: requestedIconStyle });
        }
    }, [loadIconSources, propIcon, requestedIconStyle, source]);

    if (!source) {
        return <span aria-hidden data-inline-icon-source-pending hidden />;
    }

    return <Icon ref={ref} {...props} />;
}
